<template>
  <stacked-bar-chart-card
    :size="size"
    title="위험성 결정 현황"
    :value="data"
    :init-total="total"
    :labels="labels"
    :x-axis="xAxis"
    unit="건"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></stacked-bar-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import StackedBarChartCard from "@/components/StackedBarChartCard.vue";

export default {
  name: 'DonutChart09Dbm',
  components: {StackedBarChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
    reloadCount () {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 90,
      boardIds: [592],
      summaryKeys: {
        'detail' : ['정기위험성평가_재해형태', 'count'],
        'field' : ['정기위험성평가_사업장명', 'count'],
        'address' : ['정기위험성평가_재해형태', 'count'],
        'field_cat1' : ['정기위험성평가_재해형태', 'count'],
        'company' : ['정기위험성평가_재해형태', 'count'],
        'project' : ['정기위험성평가_재해형태', 'count'],
      },
      data: [{label: '데이터 없음', value: 0}],
      labels: ['1~2(L)', '3~4(ML)', '6(M)', '8~9(H)', '12~16(HH)'],
      total: [0, 0, 0, 0, 0],
      xAxis: [],
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear, depth) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (!depth) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          depth,
          currentYear,
        };

        const data = await this.$store.dispatch("summary/LOAD_DONUT_09_DETAIL_DBM", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      let graph2Data = [];
      if (!this.projectId) {
        graph2Data = data.project;
      } else {
        switch (this.getLevel) {
        case 1:
        case 2:
          graph2Data = data.company;
          break;
        case 3:
          graph2Data = data.field;
          break;
        case 4:
        default:
          graph2Data = data.disaster;
          break;
        }
      }
      // console.log('donut09', this.getLevel, {type: this.dataType, data, graph2Data});

      const currentYear = new Date().getFullYear();
      // const currentMonth = new Date().getMonth() + 1;

      // const currentData = graph2Data[currentYear][currentMonth];

      const seriesData = [
        { name: '1~2(L)', data: []},
        { name: '3~4(ML)', data: []},
        { name: '6(M)', data: []},
        { name: '8~9(H)', data: []},
        { name: '12~16(HH)', data: []},
      ];
      const xAxis = [];

      for (const monthlyData of graph2Data[currentYear]) {
        // monthlyData 항목들을 rate 값의 합으로 내림차순 정렬한다
        monthlyData.sort((a, b) => {
          const aSum = a.rate.reduce((a, b) => a + b, 0);
          const bSum = b.rate.reduce((a, b) => a + b, 0);
          return bSum - aSum;
        });

        for (const projectData of monthlyData) {
          const rate = projectData.rate;

          // rate 각 항목의 값을 total에 누적한다
          for (let i = 0; i < rate.length; i++) {
            this.total[i] += rate[i];
          }
        }

        // 만약 monthlyData의 개수가 5개를 초과하면, 5개까지만 남긴다
        if (monthlyData.length > 5) {
          monthlyData.splice(5);
        }

        for (const projectData of monthlyData) {
          const label = projectData.label;
          const rate = projectData.rate;

          xAxis.push(label);
          for (let i = 0; i < rate.length; i++) {
            seriesData[i].data.push(rate[i]);
          }
        }
      }


      // xAxis 개수가 5개 이하일 경우, 5개로 맞춘다
      if (xAxis.length < 5) {
        const diff = 5 - xAxis.length;
        for (let i = 0; i < diff; i++) {
          xAxis.push('');
        }

        // seriesData의 각 항목의 data 개수가 5개 이하일 경우, 5개로 맞춘다
        for (const item of seriesData) {
          if (item.data.length < 5) {
            const diff = 5 - item.data.length;
            for (let i = 0; i < diff; i++) {
              item.data.push(0);
            }
          }
        }
      }

      this.xAxis = xAxis;
      this.data = seriesData;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {pageType: 'write', proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
